<template>
  <div class="box">
    <div class="withdrawRapper">
      <!-- <div v-if="signCash>0 && cashType == 'CASH'" class="balanceAndBonus" ref="earnings">
        <div class="incomeBalance">
          <span>收益余额</span>
          <div>{{userBalance|handleMoney}}
            <Flash ref="incomeBalanceFlash"></Flash>
          </div>
        </div>
        <div class="bonus">
          <span>签到奖金</span>
          <div>{{signCash|handleMoney}}
            <Flash ref="bonusFlash"></Flash>
          </div>
        </div>
      </div> -->
      <div class="balance" ref="earnings">
        <h2 class="balanceTitle">账号余额</h2>
        <div class="moneyCount">{{(cashType.indexOf('CASH4XIANWAN')>-1 ? xianWan : userBalance)|handleMoney}}
          <Flash ref="balanceFlash"></Flash>
        </div>
      </div>
      <div class="method">
        <div class="withdrawMethod">
          <h2 class="withdrawTitle">提现方式</h2>
          <div class="giveDes" v-if="withdrawType == 'alipay' && isActivity">
            <span @click="newerPacket">支付宝新用户点击得8元红包</span>  
          </div>
        </div>
        <div class="chooseWithdrawMode" :class="withdrawOrder == '1' || cashType.indexOf('CASH4XIANWAN')>-1 ? '' : 'withdrawOrder'">
          <div class="wx" @click="changeMethod('wx')" :class="{choosedBorder:withdrawType === 'wx' || cashType.indexOf('CASH4XIANWAN')>-1}">
            <img src="~assets/images/withdraw/wxpay.png" alt="">
            <img class="choosedImg" v-if="withdrawType === 'wx' || cashType.indexOf('CASH4XIANWAN')>-1" src="~assets/images/withdraw/checkRight.png" alt="">
            <span>微信</span>
          </div>
          <div class="alipay" @click="changeMethod('alipay')" :class="{choosedBorder:withdrawType === 'alipay'}" v-if="cashType.indexOf('CASH4XIANWAN')<0">
            <img src="~assets/images/withdraw/alipay.png" alt="">
            <img class="choosedImg" v-if="withdrawType === 'alipay'" src="~assets/images/withdraw/checkRight.png" alt="">
            <span>支付宝</span>
            <div v-if="isActivity" class="give">
              送8元
            </div>
          </div>
        </div>
        <div class="chooseAmount" v-if="cashType.indexOf('CASH4XIANWAN')<0">
          <div class="amountAndRecode"> 
            <div class="chooseTitle">请选择提现金额</div>
            <div class="withdrawRecode" @click="goWithdrawRecode">提现记录</div>
          </div>
          <div class="chooseType">
            <div v-for="(type,index) in moneyTypes" :key="type.id" @click="chooseMoney(type.amount,index,type.missionId,type.currencyType)" :class="{choosedBorder:isChoosedNum == index}" class="chooseMoney">
              <span class="amount">&yen;{{type.amount/100}}</span>       
              <span class="descript">{{type.text}}</span>
              <img v-if="type.cornerTag == 1" class="hot" src="~assets/images/withdraw/corner.png" alt="">
              <img v-if="isChoosedNum == index" class="choosedImg" src="~assets/images/withdraw/checkRight.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <div class="withdrawDes" ref="descript">
        <div class="withdraw">
          <h2 class="withdrawTitle">提现说明</h2>
          <div class="desContent">
            <p>
              ({{ moneyTypes && moneyTypes[isChoosedNum].description}})
            </p>
          </div> 
        </div>
        <div v-if="missionInfoItem && missionInfoItem.condition == 'continuousPlayGame'" class="loginDay">
          <div class="days">
            <div v-for="d of missionInfoItem.conditionCount" :key="d" class="finishDay">
              <span :class="{chooseDayth:d < missionInfoItem.count + 1}" class="dayth">第{{d}}天</span>
              <img v-if="d < missionInfoItem.count + 1" src="~assets/images/withdraw/right_blue.png" class="daythImg" alt="">
              <img v-else src="~assets/images/withdraw/right_gray.png"  class="daythImg" alt="">
            </div>  
          </div>
          <div class="taskDescript" @click="playGames">
            <span>{{missionInfoItem.finishedTodayNote}}</span>
          </div>
          <Flash ref="taskFlash"></Flash>
        </div>
      </div>
      <div class="noticeItems">
        <h2 class="noticeTitle">注意事项</h2>
        <div class="noticeItem">
          <p v-for="(item,index) in noticeItems" :key="index">{{item}}</p>
        </div>
      </div>
      <div class="withdrawDetails">
        <div class="withdrawNum">
          <span>提现</span>
          <span>&yen;{{cashType.indexOf('CASH4XIANWAN') >-1 ? xianWan : withdrawNum}}</span>
        </div>
        <button class="goWithdraw" @click="goWithdraw">
          {{cashType.indexOf('CASH4XIANWAN') >-1 ? '全部提现' : isActivity && withdrawType=='alipay' ? '提现领红包': '去提现'}}
        </button>
      </div>
      <Modal :modalMes="modalMes"></Modal>
      <Toast :toastContent="toastContent" ref="myToast"></Toast>
    </div>
    <div v-if="unstable" class="netWork">
      <a @click="refresh">网络不稳定，点击重试</a>
    </div>
  </div>   
</template>
<script>
import Toast from '@/components/withdraw/toast'
import Flash from '@/components/withdraw/flash'
import Modal from '@/components/withdraw/modal'
import { mapState,mapMutations } from 'vuex'
import qs from 'qs'
export default {
  inject:['reload'],
  data(){
    return {
      unstable:false,
      userBalance:'--',//余额
      signCash:'--',//签到金额
      xianWan:'--',//闲玩金额
      cashType:'aa',//根据cashType渲染页面
      isActivity:false,//是否有活动
      withdrawOrder:'',//微信和支付宝的顺序
      moneyTypes:null,//提现金额类型信息
      withdrawNum:'',//提现的钱
      isChoosedNum:0,//选择提现的币值
      finishTask:false,//是否完成连续游戏的任务
      noticeItems:[],//注意事项
      num:3,//判断哪个接口返回最慢
      modalMes:null,//modal的提示信息
      toastContent:'',//toast的提示信息
      timer:null,
      // loading:{},//是否显示加载
    }
  },
  components:{
    Toast,
    Flash,
    Modal
  },
  computed:{
    ...mapState({
      basicUserInfo:'basicUserInfo',
      withdrawType:state => state.withdraw.withdrawType,
      userInfo:state => state.withdraw.userInfo,
      missionInfoItem:state => state.withdraw.missionInfoItem,
    })
  },
  filters:{
    handleMoney:function (value) {
      var formatedMoney = (value.toString().indexOf ('.') !== -1) ? value.toLocaleString() : value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      return formatedMoney
    }
  },
  created(){
    // this.loading = window.document.querySelector('.prev-css-loading')
    // 注意事项
    this.$http.get('/logic/setting/getLanguage/1000001').then(res => {
      if(res.data.return_code == 200){
        this.noticeItems = res.data.data.text.split('\\n')
      }
    })
  },
  mounted(){
    // this.loading.style.display = 'flex'
    this.getBasicUserInfo()
    this.getWithdrawInfo()
  },
  methods:{
    ...mapMutations([
      'withdraw/setWithdrawType',
      'withdraw/setCashType',
      'withdraw/setUserInfo',
      'withdraw/setMissionInfoItem',
      'withdraw/setUserInfoBindName'
    ]),
    getBasicUserInfo(){
      let basicUserInfo = JSON.parse(Android.getCommonParamsByKey(['uuid','sessionId','appVersionCode','channelId','unionId']))
      this.cashType = Android.getCashType()
      // let basicUserInfo = {unionId: "os7160S5edmzuC8gMIuC2Su-q9IQ", sessionId: "4900AF50F1060D360AA735B70545122D", uuid: "cbe3be6c11854cc7b0543b97c27ffb52", appVersionCode: 2250000, channelId: "default"}
      // this.cashType = 'CASH4XIANWAN'
      // this.cashType = 'CASH'
      // console.log(basicUserInfo,'basicUserInfo');  
      // console.log(this.cashType,'this.cashType');

      this['withdraw/setCashType'](this.cashType)
      this.$store.commit('setBasicUserInfo', basicUserInfo)   
      collect('event_withdraw_page_show',{
        currencyType: this.cashType,
      }) 
    },
    getWithdrawInfo(){ 
      // 取url上的参数看是否有活动        
      this.isActivity = Android.hasAliPayActivity()
      // this.$http.get('http://easymock.233wei.cn/mock/5df8471f7967af073af3ef95/logic/user/userInfo?sessionId=11').then(res => {
      //   console.log(res.data.data,'data');
        
      //   this.userBalance = Number(res.data.data.userBalance)/100
      //   this.signCash = Number(res.data.data.CASH4QIANDAO)/100
      //   this.xianWan = Number(res.data.data.CASH4XIANWAN)/100
      //   this['withdraw/setUserInfo'](res.data.data)
      // })
      console.log(this.basicUserInfo,'basicUserInfo');
      
      this.$http.get('/logic/user/userInfo',{     
        params:{
          uuid:this.basicUserInfo.uuid,
          sessionId:this.basicUserInfo.sessionId,
          fields:'frontRealName,frontCardNo,age,userGender,userId,signature,userIcon,userName,userBalance,userGold,withdrawCashTimes,birth,phoneNumber,cashMaxRecord,bindPhone,bindWinxin,bindQQ,openId,registerTime,wechatNickName,wechatHeadImgUrl,alipayNickName,alipayHeadImgUrl,weChatOpenId,alipayUserId,qqNickName,bindAlipay,userRealName,unionId,signCash,cash4xianwan,CASH4GAME'
        }
      }).then(res => {
        this.num = this.num - 1 
        if(this.num == 0){
          // this.loading.style.display = 'none' 
        } 
        if(res.status == 200){
          this.userBalance = Number(res.data.userBalance)/100
          this.signCash = Number(res.data.CASH4QIANDAO)/100
          this.xianWan = Number(res.data.CASH4XIANWAN)/100
          this['withdraw/setUserInfo'](res.data)
        }
      })
      // 支付宝和微信的顺序
      this.$http.get('/logic/setting/isWechatFirst').then(res => {
        this.num = this.num - 1 
        if(this.num == 0){
          // this.loading.style.display = 'none'
        } 
        if(res.data.return_code == 200){
          this.withdrawOrder = res.data.data.v
          if(this.cashType.indexOf('CASH4XIANWAN')>-1){
            this['withdraw/setWithdrawType']('wx')
          }else{
            this['withdraw/setWithdrawType'](res.data.data.v == '1' ? 'wx' : 'alipay')
          }
        }
      })
      // 可选币值
      this.$http.post(`/logic/withdraw/login/u/getWithdrawMissionInfo?appVersionCode=${this.basicUserInfo.appVersionCode}&uuid=${this.basicUserInfo.uuid}&channelId=${this.basicUserInfo.channelId}&currencyType=${this.cashType}`).then(res => {
        if(res.data.return_code == 200){
          this.num = this.num - 1 
          if(this.num == 0){
            // this.loading.style.display = 'none'
          } 
          this.moneyTypes = res.data.data
          this.withdrawNum = res.data.data[0].amount/100
          this['withdraw/setMissionInfoItem'](res.data.data[0])
        }
      })
    },
    // 点击提现按钮
    goWithdraw(){       
      // 1.判断现有金额是否到达要求提现金额
      if(!this.isReachAmount()){
        //闪动两下,提示余额不足
        this.$refs.earnings.scrollIntoView({
          block: "start", behavior: "smooth"
        })
        return 
      }
      //2.如果是支付宝提现的话，需要判断微信是否授权
      if(this.withdrawType == 'alipay'){  
        if(!this.userInfo.bindWinxin){
          // 如果微信没有授权，弹出模态框
          this.modalMes = {
            shadowIsShow:true,
            tipIsShow:true,
            title:'微信授权',
            des:'请先进行微信授权，才可继续提现',
            cancelBtn:'取消',
            toDo:'去授权'
          }
          return 
        }
      }
      // 3.提现如果是连续游戏的话，判断是否完成任务
      if(this.missionInfoItem.condition == 'continuousPlayGame'){
        if(this.missionInfoItem.conditionCount>0 && this.missionInfoItem.finishState != 1){
          this.$refs.descript.scrollIntoView({
            block: "start", behavior: "smooth"
          })
          this.tip('taskFlash','条件未达成，请查看上方提现说明')
          return
        }
      }
      // 4.要求绑定身份证或者是大额提现 但是身份证没绑定；没绑定账户；
      let bindType = this.withdrawType == 'wx' ?  'bindWinxin' : 'bindAlipay'
      if(((this.missionInfoItem.isShowId == true || this.missionInfoItem.type == '大额提现') && !this.userInfo.isBindIdCard) || !this.userInfo[bindType]){
        this.$router.push({
          path:'/money/withdrawinfo'
        })
        return 
      }
      // 5.如果是0.5元，需满足姓名已填；如果是其他金额需满足姓名和手机号已填。才能到信息页   
      if((this.missionInfoItem.amount == 50 && this.userInfo.userRealName) || ((this.missionInfoItem.amount != 50 || this.cashType.indexOf('CASH4XIANWAN')>-1) && this.userInfo.userRealName && this.userInfo.phoneNumber)){
        let identityInfo = this.missionInfoItem.amount == 50 ? {name:this.userInfo.userRealName} : {name:this.userInfo.userRealName,cardNo:'',phone:this.userInfo.phoneNumber} 
        let withdrawId = this.withdrawType == 'wx' ? {openId:this.userInfo.weChatOpenId} : {account:this.userInfo.alipayUserId}
        let currencyType
        if(this.missionInfoItem.currencyType.indexOf('CASH4QIANDAO')>-1){
          currencyType = 'CASH4QIANDAO'
        }else if(this.missionInfoItem.currencyType.indexOf('CASH4XIANWAN')>-1){
          currencyType = 'CASH4XIANWAN'
        }else if(this.missionInfoItem.currencyType.indexOf('CASH4GAME')>-1){
          currencyType = 'CASH4GAME'
        }else{
          currencyType = null
        }
        this.$http.post('/logic/withdraw/login/u/withdrawConfirmPhone',qs.stringify({ 
          currencyType:currencyType,
          missionId:this.missionInfoItem.missionId,
          unionId:this.basicUserInfo.unionId,
          uuid:this.basicUserInfo.uuid,
          appVersionCode:this.basicUserInfo.appVersionCode,
          channelId:this.basicUserInfo.channelId,
          selfPackageName:Android.getPkgName(),//需要明彬传
          ...withdrawId,
          ...identityInfo
        }, {skipNulls: true }),{
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
          }
        }).then(res => {
          if(res.data.return_code == 200){
            collect('event_withdraw_apply_success',{
              missionId:this.missionInfoItem.missionId, 
              withdrawAmount:this.missionInfoItem.withdrawAmount/100,
              currencyType: this.missionInfoItem.currencyType,
              deductAmount:this.missionInfoItem.withdrawAmount/100,
              withdrawMethod:this.withdrawType == 'wx' ? 1 :2,
            })
            this['withdraw/setUserInfoBindName'](identityInfo.name)   
            this.$router.push({
              path:'/money/withdrawSuccess'
            })
          }else{
            this.toastContent = res.data.return_msg
            this.$refs.myToast.toast()
          }
        }) 
      }else{
        collect('event_withdraw_jump_success',{
          missionId:this.missionInfoItem.missionId,
          withdrawAmount:this.missionInfoItem.withdrawAmount/100,
          currencyType: this.missionInfoItem.currencyType,
          deductAmount:this.missionInfoItem.withdrawAmount/100,
          withdrawMethod:this.withdrawType == 'wx' ? 1 :2
        })
        this.$router.push({
          path:'/money/withdrawinfo'
        })
      }
    },
    newerPacket(){
      window.location.href = 'https://render.alipay.com/p/f/jfxb4alj/pages/receive-redpacket/index.html?__webview_options__=ttb%253Dauto&partnerId=&sceneCode=KF_COMMON&shareChannel=QRCode&shareUserId=2088821689789413&sharedUserId='
    },
    isReachAmount(){    
      // if(this.signCash>0 && this.missionInfoItem.currencyType.indexOf('CASH4QIANDAO')<0 && Number(this.userBalance) < Number(this.withdrawNum)/100){
      //   this.tip('incomeBalanceFlash','收益余额不足')
      //   return false    
      // }else if(this.signCash>0 && this.missionInfoItem.currencyType.indexOf('CASH4QIANDAO')>0 && Number(this.signCash) < Number(this.withdrawNum)/100){
      //   this.tip('bonusFlash','收益余额不足')
      //   return false  
      // }else if(this.signCash <= 0 && this.missionInfoItem.currencyType.indexOf('CASH4QIANDAO')<0 && Number(this.userBalance) < Number(this.withdrawNum)/100){
      //   this.tip('balanceFlash','收益余额不足')
      //   return false  
      // }
      if(Number(this.userBalance) < Number(this.withdrawNum)/100){
        this.tip('balanceFlash','收益余额不足')
        return false  
      }else if((this.xianWan <= 0 ) && this.cashType.indexOf('CASH4XIANWAN')>-1){
        this.tip('balanceFlash','收益余额不足')
        return false  
      }else{
        return true
      }
    },
    // 选择微信还是支付宝
    changeMethod(type){
      this['withdraw/setWithdrawType'](type)
    },
    // 选择提现金额
    chooseMoney(amount,index,missionId){
      this.isChoosedNum = index
      this.withdrawNum = amount/100
      this['withdraw/setMissionInfoItem'](this.moneyTypes.filter(item => {
        return item.missionId == missionId
      })[0])
    },
    // 任务未完成，点击去玩游戏
    playGames(){
      Android.goYouji()
    },
    goWithdrawRecode(){
      this.$router.push({
        path:'/money/withdrawrecode'
      })
    },
    refresh(){
      this.reload()
    },
    tip(flashName,toastCon){
      collect('event_withdraw_jump_fail',{
        missionId:this.missionInfoItem.missionId,
        withdrawAmount:this.missionInfoItem.withdrawAmount/100,
        currencyType: this.missionInfoItem.currencyType,
        deductAmount:this.missionInfoItem.withdrawAmount/100,
        withdrawMethod:this.withdrawType,
        jumpFailReason:toastCon
      })
      this.$refs[flashName].flash()   
      this.toastContent = toastCon
      this.$refs.myToast.toast()
    }
  },
  destroyed() {
    //清除定时器
    clearInterval(this.timer)
    this.timer = null
  }
  
}
</script>
<style lang="less" scoped>
.display{
  display: block !important;
}
.box{
  height: 100%;
  .withdrawRapper{
    background: #F8F8F8; 
    height: 100%;
    overflow: scroll;
    padding-bottom: 0.6rem;
    // font-family:PingFangSC-Medium,PingFang SC;
    h2{
      font-size: 0.19rem;
      color: #333;
      line-height: 0.5rem;
      font-weight:500;
    }
    .balance{
      height: 0.56rem;
      padding-top:0.08rem;
      background: #fff;
      padding-left:0.16rem;
      padding-right:0.16rem;
      line-height: 0.48rem;
      position: relative;
      overflow: hidden;
      h2{
        float: left;
      }
      .moneyCount{
        float: right;
        font-size: 0.24rem;
        color: #F35656;
        line-height: 0.48rem;
        font-weight:600;
        font-family:Arial;
        position: relative;
      }
    }
    .balanceAndBonus{
      padding-top:0.08rem;
      background: #fff;
      height: 0.7rem;
      padding-bottom: 0.1rem;
      display: flex;
      >div{
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        >span{
          color: #999;
          font-size: 0.14rem;
        }
        >div{
          color: #F35656;
          font-size: 0.18rem;
          font-weight:600;
          position: relative;
        }
      }
      >div:nth-child(1){
        >div{
          text-align: center;
          width: 100%;
          border-right: 1px solid #ccc;
        }
      }
    }
    .method{
      margin-top:0.08rem;
      padding-bottom:0.16rem;
      padding-left:0.16rem;
      padding-right:0.16rem;
      background: #fff;
      .choosedBorder{
        border: 1px solid #FF9500 !important;
      }
      .choosedImg{
        position: absolute;
        top: 0;
        left: 0;
        width: 0.2rem;
        height: 0.2rem;
      }
      .withdrawMethod{
        display:flex;
        height: 0.5rem;
        line-height: 0.5rem;
        h2{
          width: 0.8rem;
          font-size: 0.19rem;
        }
        .giveDes{
          font-size: 0.12rem;
          color: #2DA4FF;
          line-height: 0.5rem;
          width: 2.8rem;
          text-align: right;
          span{
            border-bottom: 1px solid #2DA4FF;
          }
        }
      }
      .withdrawOrder{
        flex-direction:row-reverse;
      }
      .chooseWithdrawMode{
        height:0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        >div{
          width: 1.68rem;
          height:0.4rem;
          float: left;
          border: 1px solid #ddd;
          border-radius: 0.05rem;
          position: relative;
          img:nth-of-type(1){
            vertical-align: middle;
            margin-left:0.55rem;  
            margin-right:0.1rem;
            width: 0.18rem;
            height:0.18rem;
            line-height:0.4rem;
            display: inline-block;
          }
          >span{
            vertical-align: middle;
            line-height:0.4rem;
          }
          .give{
            position: absolute;
            width: 0.6rem;
            height: 0.23rem;
            line-height: 0.23rem;
            text-align: center;
            background: #F35656;
            color: #fff;
            top: -0.12rem;
            right: 0;
            border-radius: 0.2rem;
            font-size: 0.12rem;
          }
        }
      }
      .chooseAmount{
        margin-top:0.18rem;
        .amountAndRecode{
          display: flex;
          justify-content: space-between;
          .chooseTitle{
            color: #999;
            font-size:0.13rem;
            margin-bottom: 0.05rem;
            width: 1rem;
          }
          .withdrawRecode{
            // width: 1rem;
            margin-top: -0.07rem;
            font-size: 0.12rem;
            text-align: right;
            border: 1px solid rgba(170, 170, 170,.2);
            padding: 0.06rem 0.08rem 0.02rem 0.08rem;
            // background: #01ac07;
            border-radius: 0.2rem;
          }
        }
        .chooseType{
          overflow: hidden;
          .chooseMoney{
            width: 1.09rem;
            height:0.8rem;
            border-radius: 0.05rem;
            border: 1px solid #ddd;
            float: left;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            position: relative;
            margin-top: 0.08rem;
            margin-right: 0.08rem;
            img.hot{
              width:0.28rem;
              height:0.28rem;
              display: block;
              position: absolute;
              right: -0.01rem;
              top:-0.01rem;
            }
            .amount{
              color: #333;
              font-size:0.18rem;
              font-weight:400;
              font-family:Arial;
              margin-bottom: 0.05rem;
            }
            .descript{
              color: #999;
              font-size:0.12rem;
              font-weight:400;
            }
          }
          >div:nth-child(3n+3){
            margin-right:0;
          }
        }

      }
    }
    .withdrawDes{
      background: #fff;
      padding-left:0.16rem;
      padding-right:0.16rem;
      margin-top: 0.08rem;
      .withdraw{
        display:flex;
        height: 0.5rem;
        line-height: 0.5rem;
        h2{
          width: 0.8rem;
          color: 0.13rem;
        }
        .desContent{
          font-size: 0.12rem;
          color: #999;
          line-height: 0.2rem;
          p{
            width: 2.5rem;
            height: 0.5rem;
            display: flex;
            justify-content: left;
            align-items: center;
          }
        }
      }
      .loginDay{
        border: 1px solid #ddd;
        border-radius: 0.05rem;
        position: relative;
        .days{
          overflow: hidden;
          padding-top: 0.1rem;
          >div.finishDay{
            width:0.528rem;
            height:0.6rem;
            border-radius: 0.09rem;
            text-align: center;
            border: 1px solid #E9E9E9;
            color: #fff;
            margin-left:0.13rem;
            margin-top:0.1rem;
            float: left;
            .dayth{
              display: block;
              height:0.27rem;
              background: #E9E9E9;
              border-top-left-radius:0.09rem;
              border-top-right-radius:0.09rem;
            }
            .chooseDayth{
              width: 100%;
              background: #FF9500;
              border: 1px solid #FF9500 !important;
              box-sizing: content-box;
              margin-left: -1px;
              margin-top: -1px;
            }
            .daythImg{
              width: 0.2rem;
              margin-top: 0.03rem;
            }
          }
        }
        .taskDescript{
          color: #FF9500;
          font-size:0.14rem;
          margin-top:0.2rem;
          margin-bottom:0.2rem;
          text-align: center;
          span{
            border-bottom: 1px solid #FF9500;
          }
        }
        .taskTip{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          right: 0;
          background-color:rgba(170, 170, 170,.5);
          display: none;
        }
      }
    }
    .noticeItems{
      padding-left:0.16rem;
      padding-right:0.16rem;
      padding-bottom: 0.2rem;
      background: #fff;
      p{
        font-size: 0.12rem;
        line-height: 0.3rem;
        // margin-top:0.06rem;
        color: #999;
        &:first-child{
          margin-top:0;
        }
      }
    }
    .withdrawDetails{
      width: 100%;
      height: 0.6rem;
      background: #fff;
      border-top: 1px solid #E9E9E9;
      position: fixed;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .withdrawNum{
        float: left;
        >span:first-child{
          color: #333;
          font-size: 0.12rem;
          margin-left: 0.16rem;
          margin-right: 0.08rem;
        }
        >span:nth-child(2){
          color: #F35656;
          font-size: 0.24rem;
          font-weight:600;
          font-family:Arial;
        }
      }
      button{
        float: right;
        width: 1.47rem;
        height:0.4rem;
        background: #FF9500;
        color: #fff;
        font-size:0.16rem;
        text-align: center;
        line-height: 0.4rem;
        margin-right: 0.16rem;
        border-radius: 0.2rem;
        border:1px solid #FF9500;
        border: 0;
        outline: none;
      }
    }
  }
  .netWork{
    height: 100%;
    text-align: center;
  }
  .netWork a{
    position: absolute;
    left: 50%;
    top: 50%;
    color:#01ac07;
    border-bottom: 1px solid #01ac07;
    margin-left: -0.8rem;
    margin-top: -0.3rem;
    font-size: 0.16rem;
  }
}
</style>